// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"ccb7fd30","969":"d2cffde6","1771":"c3956634","4188":"0ee37d94","6335":"ccb7fd30"}[chunkId] + ".chunk.css";
};